<template>
  <div>
    <v-row no-gutters class="justify-center mr-8 ml-5">
      <v-col lg="6" md="12" cols="12" class="pa-0">
        <v-card>
          <v-card-title class="xlg--text fontweight400 pt-6"
            >Support</v-card-title
          >
          <v-card-text class="text--primary">
            <p class="fontlight--text xs--text">
              If you have a problem or just want to chat about your web-scraping
              needs, please, contact us via
              <a
                class="text-decoration router-link"
                href="mailto:support@scrapingant.com"
                >support@scrapingant.com</a
              >
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "Support",
};
</script>

<style scoped>
</style>